<div class="tables-wrapper">
  <mat-accordion
    class="horizontal-accordion"
    [multi]="true"
  >
    @for (panel of createAudiencePanelsConfig(audienceParams()); track $index) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="title">
              {{ panel.title }}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @if (audienceParams()) {
          <div class="data-wrapper">
            <ng-container
              *ngComponentOutlet="panel.component; inputs: panel.inputs"
            ></ng-container>
          </div>
        }
      </mat-expansion-panel>
    }
  </mat-accordion>
  <mat-accordion [multi]="true">
    @for (key of bloggerModalResourcesKeys; track $index) {
      <mat-expansion-panel [expanded]="$index === 0">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="title">
              {{ bloggerModalResources[key].name }}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="data-wrapper">
          <app-records-table-container
            [resourceParams]="bloggerModalResources[key]"
            [isFullHeight]="false"
            [defaultFilters]="{
              bloggerId: bloggerId()
            }"
            [defaultSort]="getTableSort(key)"
            [defaultNewRecordFields]="{
              bloggerId: bloggerId()
            }"
          />
        </div>
      </mat-expansion-panel>
    }
  </mat-accordion>
</div>
